import React from "react";
import { LockIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
type SectionCtaProps = {
  label: string;
  note?: string;
  tone?: "light" | "dark";
};
export function SectionCta({
  label,
  note = "Instant digital access · One-time payment of $27 USD",
  tone = "light"
}: SectionCtaProps) {
  return <div className="mt-10 sm:mt-12" data-id="element-67" data-mp="3nb8ght2x31md">
      <CtaButton label={label} data-id="element-68" data-mp="3necs3bipozn2" />
      <p className={`mt-4 flex items-center justify-center gap-1.5 text-center text-sm font-medium ${tone === "dark" ? "text-brand-sky" : "text-muted"}`} data-id="element-69" data-mp="38n3ticwu03xs">
        <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-70" data-mp="2zn7dt0sf6fev" />
        {note}
      </p>
    </div>;
}